// «Entrar como» un usuario: la sesión vive en localStorage del dominio, igual que
// cualquier otra. Si en ese dominio ya había una sesión (la del propio admin,
// por ejemplo), se guarda aparte al entrar y se devuelve al salir o al vencer.
import { TokenValidator } from './tokenValidator';

const RESPALDO = 'suplantacion_respaldo';

export const guardarRespaldoSesion = () => {
  try {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    // Entrar dos veces seguidas no debe pisar el respaldo con otra suplantación.
    if (!token || !user || user.suplantacion) return;
    localStorage.setItem(RESPALDO, JSON.stringify({ token, user }));
  } catch (e) { /* sin respaldo: al salir queda sin sesión */ }
};

// Devuelve { token, user } si había una sesión previa aún vigente (y la quita).
export const tomarRespaldoSesion = () => {
  try {
    const r = JSON.parse(localStorage.getItem(RESPALDO) || 'null');
    localStorage.removeItem(RESPALDO);
    if (r?.token && r?.user && !TokenValidator.isTokenExpired(r.token)) return r;
  } catch (e) { /* respaldo ilegible */ }
  return null;
};
